import React from "react";

import { useAppSelector } from "../../redux/store";
import "../../layout/Leftnav/leftnav.scss";

export default function NavitemExpand({
  label,
  icon,
  expandIcon,
  onClick,
  children,
  subChildren,
  className,
  secondLevelLeftnav,
  id,
}: {
  label: string;
  icon?: React.ReactNode;
  expandIcon?: React.ReactNode;
  onClick?: () => void;
  children: React.ReactNode;
  subChildren?: boolean;
  className?: string;
  secondLevelLeftnav?: boolean;
  id?: string;
}) {
  const { isCollapsed } = useAppSelector((state) => state.sidebar);

  return (
    <div
      className={`nav-expand ${subChildren ? "second-level-nav-expand" : ""} ${className ?? ""}`}
      id={id}
    >
      <div
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={onClick}
      >
        <div className="d-flex">
          <div className={`side-header ${subChildren ? "ms-3" : ""}`}>
            {icon}
            {!isCollapsed && label}
          </div>
        </div>
        {!isCollapsed && (
          <div className={`me-2`}>{expandIcon && expandIcon}</div>
        )}
      </div>
      <div className="d-flex position-relative w-100 api-dropdownbox">
        {!subChildren && !secondLevelLeftnav && (
          <div className={`${"border-box-right"}`}></div>
        )}
        <div className={`w-100`}>{children}</div>
      </div>
    </div>
  );
}
